import { destroy } from 'services/billing'

export async function deleteCoupon(couponId: string | number): Promise<void> {
  const response = await destroy('/coupons', couponId)
  return response
}
